import { convertCamelCaseToCapitalize, convertSnakeCaseToNoCaseCapitalize } from "@/utils/str";

/**
 * Overrides for values whose machine name does not capitalize into the
 * product-preferred wording (e.g. the `DutyStatus.sleeperBed` enum is
 * displayed to dispatchers as "Sleeper Berth").
 */
const DUTY_STATUS_DISPLAY_OVERRIDES: Record<string, string> = {
  sleeperBed: "Sleeper Berth",
};

export function formatDutyStatusLabel(rawStatus: string | null | undefined): string {
  if (!rawStatus) return "";
  const override = DUTY_STATUS_DISPLAY_OVERRIDES[rawStatus];
  if (override) return override;
  return convertCamelCaseToCapitalize(convertSnakeCaseToNoCaseCapitalize(rawStatus));
}
